var exports = {
  "D": "xa15a2ab7--fbb9d3--title",
};

module.exports = exports;
